import React from 'react';
import { registerForIntl, provideIntlService } from '@progress/kendo-react-intl';
import moment from 'moment';

class DateFormatter extends React.Component {
    render() {
        
        return (
            
            <span> {moment.utc(this.props.date).local().format('DD-MMM-YYYY HH:mm')}</span>
            
        );
    }
}

registerForIntl(DateFormatter);

export default DateFormatter;